__turbopack_context__.v({
  "blurImage": "listing-card-v3-module-scss-module__2XkoeW__blurImage",
  "bottomContent": "listing-card-v3-module-scss-module__2XkoeW__bottomContent",
  "component": "listing-card-v3-module-scss-module__2XkoeW__component",
  "dateAdded": "listing-card-v3-module-scss-module__2XkoeW__dateAdded",
  "favouriteChrome": "listing-card-v3-module-scss-module__2XkoeW__favouriteChrome",
  "gatedBody": "listing-card-v3-module-scss-module__2XkoeW__gatedBody",
  "gatedPill": "listing-card-v3-module-scss-module__2XkoeW__gatedPill",
  "image": "listing-card-v3-module-scss-module__2XkoeW__image",
  "media": "listing-card-v3-module-scss-module__2XkoeW__media",
  "mediaVeil": "listing-card-v3-module-scss-module__2XkoeW__mediaVeil",
  "priceRow": "listing-card-v3-module-scss-module__2XkoeW__priceRow",
  "providerMeta": "listing-card-v3-module-scss-module__2XkoeW__providerMeta",
  "pvrDate": "listing-card-v3-module-scss-module__2XkoeW__pvrDate",
  "row": "listing-card-v3-module-scss-module__2XkoeW__row",
  "smartTagBadge": "listing-card-v3-module-scss-module__2XkoeW__smartTagBadge",
  "smartTags": "listing-card-v3-module-scss-module__2XkoeW__smartTags",
  "statusChrome": "listing-card-v3-module-scss-module__2XkoeW__statusChrome",
  "statusPill": "listing-card-v3-module-scss-module__2XkoeW__statusPill",
  "streetAddress": "listing-card-v3-module-scss-module__2XkoeW__streetAddress",
  "wrapper": "listing-card-v3-module-scss-module__2XkoeW__wrapper",
});
